module.exports = __webpack_public_path__ + "static/00033.fce3920a.jpg";